import { GoWorkflow } from 'react-icons/go';
import { ChatControllerBaseConfig } from '../../base';
import { SolutionToolController } from './solutionPartInterface';

export function createSolutionToolController(
    config: ChatControllerBaseConfig
): SolutionToolController {
    return {
        useProps(context, item, props) {
            const { tool, document } = item;

            // Use document title if available, otherwise fall back to artifact info
            const artifactCount = tool.result?.artifacts?.length || 0;

            const label = document?.title ?? 'Archived document';

            const description =
                document?.description ||
                (tool.state === 'result'
                    ? 'Solution created successfully'
                    : 'Creating solution...');

            return {
                item: {
                    type: {
                        label: 'Interview',
                    },
                    label,
                    description,
                    icon: document?.icon
                        ? {
                              kind: 'emoji',
                              text: document.icon,
                          }
                        : {
                              kind: 'icon',
                              Icon: GoWorkflow,
                          },
                    tooltip: {
                        label: description,
                    },
                    Icon: GoWorkflow,
                },
                button: {
                    onClick(event) {
                        props.onNavigate();
                    },
                },
            };
        },
    };
}
